import { IStoreState } from 'src/models';

export const preAuthorizedDebitViewModelSelector = ({ page }: IStoreState) => {
	return {
		copy: {
			...page.copy.padAgreement,
		},
	};
};
